import React, { Component, useEffect, useState } from "react";
import { Col, Card, Row, FormLabel, FormGroup } from "react-bootstrap";
import {getMensagens} from '../../data/api/gsConnectApi';
import NotificationAlert from "react-notification-alert";

function DashboardItemComponent({ titulo, tipo }) {
  const [total, setTotal] = useState(null);

  useEffect(() => {

    let count = 0;
    if (tipo == 'hoje') {
      const dataHoje = new Date(Date.now());
      const dataInicio = new Date(dataHoje.getFullYear(), dataHoje.getMonth(), dataHoje.getDate())
      getMensagens(tipo, dataInicio, dataInicio).then(function(data) {
        setTotal(data.length);
      }).catch(function () {
        
      });
    } else if (tipo == 'ultimos15dias') {
      const dataHoje = new Date(Date.now());
      const ultimos15Dias = new Date(dataHoje - 1296000000);
      getMensagens(tipo, ultimos15Dias, dataHoje).then(function(data) {
        setTotal(data.length);
      }).catch(function () {
        
      });
    } else if (tipo == 'ultimos30dias') {
      const dataHoje = new Date(Date.now());
      const ultimos15Dias = new Date(dataHoje - 2592000000);
      getMensagens(tipo, ultimos15Dias, dataHoje).then(function(data) {
        setTotal(data.length);
      }).catch(function () {
        
      });
    } else {
      getMensagens(tipo).then(function(data) {
        setTotal(data.length);
      }).catch(function () {
        
      });
    }
  }, [])




  return (<Col md='4'>
    <Card>
      <Card.Header><FormLabel style={{ fontSize: 20 }}>{titulo}</FormLabel></Card.Header>
      <Card.Body>
        <Row>
          <Col><FormLabel as='h5'>{total}</FormLabel></Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>
  );
}

export default DashboardItemComponent;